export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14830.d00c27dd.jpg";